export default __webpack_public_path__ + "static/media/ttshlogo.7f99bdbb.png";